export default "__VITE_ASSET__CA_zHN8z__"